import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

const TABS = [
  {
    labelKey: "trading.costs.tab1",
    rows: [
      { labelKey: "trading.costs.cost.r1.label", descKey: "trading.costs.cost.r1.desc" },
      { labelKey: "trading.costs.cost.r2.label", descKey: "trading.costs.cost.r2.desc" },
      { labelKey: "trading.costs.cost.r3.label", descKey: "trading.costs.cost.r3.desc" },
      { labelKey: "trading.costs.cost.r4.label", descKey: "trading.costs.cost.r4.desc" },
    ],
  },
  {
    labelKey: "trading.costs.tab2",
    rows: [
      { labelKey: "trading.costs.control.r1.label", descKey: "trading.costs.control.r1.desc" },
      { labelKey: "trading.costs.control.r2.label", descKey: "trading.costs.control.r2.desc" },
      { labelKey: "trading.costs.control.r3.label", descKey: "trading.costs.control.r3.desc" },
      { labelKey: "trading.costs.control.r4.label", descKey: "trading.costs.control.r4.desc" },
    ],
  },
];

function LowerCosts() {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);
  const tab = TABS[active];

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[45px] items-start">
          <div className="lg:w-[373px] shrink-0">
            <SectionTitle
              title1={t("trading.costs.title1")}
              title2={t("trading.costs.title2")}
              text={t("trading.costs.subtitle")}
              align="left"
            />
          </div>

          <Fade triggerOnce direction="right" duration={700} className="flex-1 w-full">
          <div className="rounded-[24px] border border-[#e4edf7] overflow-hidden bg-white">
            {/* Табы */}
            <div className="flex gap-[12px] pl-[28px] pr-[32px] py-[16px] border-b border-[#e4edf7]">
              {TABS.map((item, i) => (
                <button
                  key={item.labelKey}
                  type="button"
                  onClick={() => setActive(i)}
                  className={clsx(
                    "flex items-center justify-center h-[40px] px-[16px] rounded-full font-['Inter'] font-bold text-[14px] transition-colors duration-200",
                    active === i
                      ? "bg-[#1c385f] text-white"
                      : "bg-white border border-[#e4edf7] text-[#435c7f] hover:bg-[#f5f8fc]"
                  )}
                >
                  {t(item.labelKey)}
                </button>
              ))}
            </div>

            {/* Заголовок секции */}
            <div className="flex items-stretch bg-[#eef4ff] border-b border-[#e4edf7]">
              <div className="w-[4px] bg-[#1c385f] shrink-0" />
              <p className="flex-1 pl-[28px] pr-[32px] py-[20px] font-['Inter'] font-bold text-[16px] text-[#1c385f]">
                {t(tab.labelKey)}
              </p>
            </div>

            {/* Строки */}
            {tab.rows.map((row, i) => (
              <div
                key={row.labelKey}
                className={clsx(
                  "flex flex-col lg:flex-row",
                  i < tab.rows.length - 1 && "border-b border-[#e4edf7]",
                  i % 2 === 1 ? "bg-[#f8fbff]" : "bg-white"
                )}
              >
                <p className="lg:w-[400px] shrink-0 px-[24px] lg:px-[32px] pt-[20px] lg:py-[20px] font-['Inter'] font-bold text-[16px] text-[#1c385f] lg:border-r lg:border-[#e4edf7]">
                  {t(row.labelKey)}
                </p>
                <p className="flex-1 px-[24px] lg:px-[32px] pb-[20px] pt-[6px] lg:py-[20px] font-['Inter'] font-normal text-[14px] lg:text-[16px] text-[#435c7f]">
                  {t(row.descKey)}
                </p>
              </div>
            ))}
          </div>
          </Fade>
        </div>
      </div>
    </section>
  );
}

export default LowerCosts;
